/**
 * Token 管理器
 * 负责邀请用户认证令牌的存储、获取、更新和状态管理
 * @author 杨俊朗
 */
import { canUseWindow } from "@/utils/canuseWindow";

// 事件类型定义
type InviteTokenParams = {
  inviteToken: string;
}

type InviteTokenEvent = CustomEvent<InviteTokenParams>;


export class IamInviteIamTokenManager {
  private static instance: IamInviteIamTokenManager;
  private readonly EVENT_KEY = "MIUTA_INVITE_TOKEN_CHANGE";

  // Token 状态
  private invitToken = "";

  private constructor() {
    // 
  }

  public static getInstance(): IamInviteIamTokenManager {
    if (!IamInviteIamTokenManager.instance) {
      IamInviteIamTokenManager.instance = new IamInviteIamTokenManager();
    }
    return IamInviteIamTokenManager.instance;
  }

  // ==================== Token 管理 ====================

  /**
   * 获取当前 Token
   * @returns 当前存储的 Token 字符串
   */
  public get(): string {
    return this.invitToken;
  }

  /**
   * 更新 Token
   * @param token 新的 Token 值
   */
  public update(token: string): void {
    this.invitToken = token;
    this.dispatch();
  }

  /**
   * 清除 Token
   */
  public clear(): void {
    this.update("");
  }

  // ==================== 事件管理 ====================

  /**
   * 添加 Token 状态变化监听器
   * @param listener 监听器函数
   * @returns 移除监听器的函数
   */
  public listen(listener: (e: InviteTokenEvent) => void) {
    if (canUseWindow()) {
      window.addEventListener(this.EVENT_KEY, listener);

      return () => {
        window.removeEventListener(this.EVENT_KEY, listener);
      };
    }
  }

  /**
   * 触发 Token 状态变化事件
   */
  private dispatch(): void {
    if (!canUseWindow()) {
      return;
    }

    const event = new CustomEvent<{
      inviteToken: string;
    }>(this.EVENT_KEY, {
      detail: {
        inviteToken: this.invitToken,
      },
    });

    window.dispatchEvent(event);
  }
}

// 创建单例实例
export const iamInviteIamTokenManager = IamInviteIamTokenManager.getInstance();
